<template>
  <div v-if="tripCount" class="datatable-wrapper">
    <div class="dataTables_wrapper dt-foundation no-footer">
      <table class="datatable datatable-row-click dataTable no-footer" role="grid"
             style="width: 800px;">
        <thead>
          <table-header :order-by="orderBy"
                        :order-direction="orderDirection"
                        :columns="headerColumns"
                        translation-prefix="trip.headerColumns."
                        @orderingChanged="setOrderingAndLoadData"/>
        </thead>
        <tbody>
          <tr is="trip-list-item"
              v-for="tripSummary in trips"
              :trip="tripSummary"
              :key="tripSummary.name"/>
        </tbody>
      </table>
      <p class="trip-amount-ex-vat-info">* Bedragen exclusief BTW</p>
      <div class="bottom">
        <div class="dataTables_paginate paging_full_numbers">
          <trips-list-paginator @paginationChanged="loadData"/>
        </div>
        <div class="dataTables_length">
          <label>
            <select-input
              id="page_size"
              :value="'' + pageSize"
              :options="pageSizeOptions"
              :$v="$v.pageSize"
              name="page-size"
              @change="setPageSize"
            />
            items per pagina
          </label>
        </div>
      </div>
      <div class="clear"/>
      <div class="button-set">
        <a class="button alt"
           @click="onCardPageButtonClick"
        >Overzicht mijn passen</a>
        <a class="button"
           @click="downloadCardTripsExport"
        >Selectie exporteren</a>
      </div>
    </div>
  </div>
  <div v-else class="feedback information">
    {{ $t('generic.no-results') }}
  </div>
</template>

<script>
import { mapState } from 'vuex'
import SelectInput from '../forms/fields/SelectInput'
import { SET_PAGE_SIZE, SET_ORDER_BY, SET_ORDER_DIRECTION } from '../../store/modules/trip/mutation-types'
import TripsListPaginator from './TripListPaginator'
import TripListItem from './TripListItem'
import ShowAlertErrorHandler from '../../mixins/show-alert-error-handler'
import {buildTableHeaderColumn} from '../../types/table-header-column'
import TableHeader from '../../components/tableHeader/TableHeader'

export default {
  name: 'TripsList',
  components: {
    SelectInput,
    TripsListPaginator,
    TripListItem,
    TableHeader
  },
  mixins: [ShowAlertErrorHandler],
  props: {
    cardDetails: {
      type: Object,
      required: true
    }
  },
  data: function () {
    return {
      pageSizeOptions: [
        { value: '10', text: '10' },
        { value: '25', text: '25' },
        { value: '50', text: '50' },
        { value: '100', text: '100' }
      ],
      headerColumns: [
        buildTableHeaderColumn('invoiceNumber'),
        buildTableHeaderColumn('checkinDatetime'),
        buildTableHeaderColumn('checkoutDatetime'),
        buildTableHeaderColumn('description'),
        buildTableHeaderColumn('brutoAmount')
      ]
    }
  },
  computed: {
    ...mapState({
      page: state => state.trip.tripsPage,
      pageSize: state => state.trip.pageSize,
      currentPage: state => state.trip.pageNumber,
      orderBy: state => state.trip.orderBy,
      orderDirection: state => state.trip.orderDirection,
      filterInvoiceNumber: state => state.trip.filterInvoiceNumber,
      filterCheckinMonth: state => state.trip.filterCheckinMonth,
      filterCheckinDateFrom: state => state.trip.filterCheckinDateFrom,
      filterCheckinDateTo: state => state.trip.filterCheckinDateTo
    }),
    trips: function () {
      return this.page !== null ? this.page.trips : []
    },
    tripCount: function () {
      return this.page !== null ? this.page.count : 0
    }
  },
  methods: {
    loadData: function () {
      this.$emit('update')
    },
    setPageSize: function (value) {
      value = parseInt(value)
      this.$store.commit(`trip/${SET_PAGE_SIZE}`, value)
      this.loadData()
    },
    onCardPageButtonClick () {
      this.$router.push({name: 'card'})
    },
    async downloadCardTripsExport () {
      try {
        await this.$container.b2bClient.downloadCardTripsExportFile(
          this.cardDetails.cardId,
          this.filterInvoiceNumber,
          this.filterCheckinMonth,
          this.filterCheckinDateFrom,
          this.filterCheckinDateTo
        )
      } catch (error) {
        this.showAlertForErrorAndRedirectToRoute(
          error,
          {401: this.$t('generic.jwt-expired')},
          {401: {name: 'login'}})
      }
    },
    setOrderingAndLoadData (ordering) {
      this.$store.commit(`trip/${SET_ORDER_BY}`, ordering.orderBy)
      this.$store.commit(`trip/${SET_ORDER_DIRECTION}`, ordering.orderDirection)
      this.loadData()
    }
  },
  validations () {
    return {
      pageSize: {}
    }
  }
}
</script>

<style scoped>
.button-set {
  margin-top: 5em;
}
</style>



// WEBPACK FOOTER //
// src/components/trips/TripList.vue